import { render, staticRenderFns } from "./withdraw-card.vue?vue&type=template&id=0031f260&scoped=true"
import script from "./withdraw-card.vue?vue&type=script&lang=js"
export * from "./withdraw-card.vue?vue&type=script&lang=js"
import style0 from "./withdraw-card.vue?vue&type=style&index=0&id=0031f260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031f260",
  null
  
)

export default component.exports